import styles from "./index.css";
import config from "../../config/common";
import { Fragment } from "react";

const addAdvert = ({ advert, items, positionFinder }) => {
  const {
    adverts: { adPosition }
  } = config;

  if (!advert) {
    return [...items];
  }

  const positionInItemsArray = positionFinder({
    configuredPosition: adPosition,
    items
  });

  return [
    ...items.slice(0, positionInItemsArray),
    <Fragment key="advert">
      <li className={styles.advertContainer}>
        {advert({ className: styles.advert })}
      </li>
    </Fragment>,
    ...items.slice(positionInItemsArray)
  ];
};

export default addAdvert;
